import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionProductDescriptionService {

  constructor(private httpClientService:HttpClientService) { }
  async removeTransactionProductService(id){
    const observable:Observable<any> = this.httpClientService.delete({
      controller:ControllerType.TransactionProductDescription
    },id);
    return await firstValueFrom(observable);
  }
}
